// import React, { useEffect, useState } from 'react';
// import { Editor, EditorState } from 'draft-js';
// import { 
//   Grid, 
//   IconButton, 
//   Tooltip, 
//   Paper,
//   Box,
//   Typography,
//   Fade
// } from '@material-ui/core';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
// import CloseIcon from '@mui/icons-material/Close';
// import TranslateIcon from '@mui/icons-material/Translate';
// import { FaBookOpen } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useDispatch, useSelector } from 'react-redux';
// import { openLowerModalAndCloseLeftNavbar } from '../../../redux/handleSideNavBarAndModel/handleStatus.action';
// import { checkAIRequestLimit } from '../../aiRequestLimit';
// import CoAuther_TranslatorPage from './CoAuther_Translator/CoAuther_TranslatorPage';
// import CoAuther_ParaphraserPage from './CoAuther_Paraphraser/CoAuther_ParaphraserPage';
// import CoAuther_SummariserPage from './CoAuther_Summariser/CoAuther_SummariserPage';
// import paraphrase_logo from "../../../static/Paraphrase 1.png";
// import paraphrase_logo1 from "../../../static/Paraphraser_White.png";

// const useStyles = makeStyles((theme) => ({
//   modalContainer: {
//     position: 'fixed',
//     right: 0,
//     top: '80px',
//      width: '440px',
//     // height: 'calc(97vh - 80px)',
//     // height: "620px",
//     height: 'calc(100vh - 110px)',  
//     zIndex: 1000,
//     transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//     boxShadow: '-8px 0 40px rgba(0, 0, 0, 0.15)',
//    overflow: 'scroll',             
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   mobileContainer: {
//     position: 'fixed',
//     top: '135px',
//     right: '5px',
//     width: '90%',
//     height: 'calc(100vh - 145px)',
//     zIndex: 1000,
//     boxShadow: '0 12px 48px rgba(0, 0, 0, 0.18)',
//     overflow: 'hidden',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     padding: '12px 16px',
//     borderBottom: '1px solid',
//     flexShrink: 0,
//   },
//   tabsContainer: {
//     display: 'flex',
//     gap: '8px',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//   },
//   tabButton: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
//     padding: '8px 12px',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     border: '2px solid',
//     outline: 'none',
//   },
//   activeTabButton: {
//     border: 'none',
//   },
//   contentArea: {
//     flex: 1,
//     overflowY: 'auto',
//     overflowX: 'hidden',
//     '&::-webkit-scrollbar': {
//       width: '8px',
//     },
//     '&::-webkit-scrollbar-track': {
//       background: 'transparent',
//       margin: '8px 0',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       background: 'linear-gradient(180deg, rgba(61, 131, 250, 0.3), rgba(142, 84, 233, 0.3))',
//       borderRadius: '10px',
//       border: '2px solid transparent',
//       backgroundClip: 'padding-box',
//       '&:hover': {
//         background: 'linear-gradient(180deg, rgba(61, 131, 250, 0.5), rgba(142, 84, 233, 0.5))',
//         backgroundClip: 'padding-box',
//       },
//     },
//   },
//   closeButton: {
//     padding: '8px',
//     borderRadius: '8px',
//   },
// }));

// const CustomTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: 'blue',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }))(Tooltip);

// const CoAuthorLowerModel = (props) => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const { lowerModelOpen } = useSelector(state => state.handleModelAndSideBavBar);
//   const userDetails = useSelector((user) => user);
//   const userID = userDetails.user.currentUser._id;
//   const [isDarkMode, setIsDarkMode] = useState(false);

//   useEffect(() => {
//     const updateTheme = () => {
//       const theme = localStorage.getItem('ThemeSwitch');
//       setIsDarkMode(theme === 'true');
//     };
//     updateTheme();
//     window.addEventListener('storage', updateTheme);
//     const originalSetItem = localStorage.setItem;
//     localStorage.setItem = function (key, value) {
//       originalSetItem.apply(this, arguments);
//       if (key === 'ThemeSwitch') {
//         updateTheme();
//       }
//     };
//     return () => {
//       window.removeEventListener('storage', updateTheme);
//       localStorage.setItem = originalSetItem;
//     };
//   }, []);

//   const deleteEditorFroSummarizer = (value) => {
//     if (value === true) {
//       props.handleDeleteinSummarizer(true);
//     }
//   };

//   async function handleParaphrase() {
//     // const checkailimit = await checkAIRequestLimit(userID);
//     // if (checkailimit === false) {
//     //   toast.warn("AI request limit reached.");
//     //   return;
//     // }
//     props.setTrackIsModalOpen(true);
//     props.setTranslator(false);
//     props.setSummariser(false);
//     props.setParaphraser(true);
//     dispatch(openLowerModalAndCloseLeftNavbar());
//   }

//   async function handleSummarise() {
//     // const checkailimit = await checkAIRequestLimit(userID);
//     // if (checkailimit === false) {
//     //   toast.warn("AI request limit reached.");
//     //   return;
//     // }
//     props.setTrackIsModalOpen(true);
//     dispatch(openLowerModalAndCloseLeftNavbar());
//     props.setTranslator(false);
//     props.setSummariser(true);
//     props.setParaphraser(false);
//   }

//   async function handleTranslate() {
//     // const checkailimit = await checkAIRequestLimit(userID);
//     // if (checkailimit === false) {
//     //   toast.warn("AI request limit reached.");
//     //   return;
//     // }
//     props.setTrackIsModalOpen(true);
//     dispatch(openLowerModalAndCloseLeftNavbar());
//     props.setTranslator(true);
//     props.setSummariser(false);
//     props.setParaphraser(false);
//   }

//   const TabButton = ({ active, onClick, icon, label, color, tooltip }) => {
//     const buttonContent = (
//       <div
//         className={`${classes.tabButton} ${active ? classes.activeTabButton : ''}`}
//         onClick={onClick}
//         onMouseDown={(e) => e.preventDefault()} // Prevent default mousedown behavior
//         style={{
//           backgroundColor: active ? color : 'transparent',
//           color: active ? '#fff' : (isDarkMode ? '#9ca3af' : color),
//           borderColor: active ? 'transparent' : (isDarkMode ? '#374151' : '#e5e7eb'),
//           pointerEvents: 'auto',
//         }}
//         onMouseEnter={(e) => {
//           if (!active) {
//             e.currentTarget.style.backgroundColor = isDarkMode ? '#374151' : '#f3f4f6';
//           }
//         }}
//         onMouseLeave={(e) => {
//           if (!active) {
//             e.currentTarget.style.backgroundColor = 'transparent';
//           }
//         }}
//       >
//         <div style={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center',
//           width: '20px',
//           height: '20px'
//         }}>
//           {icon}
//         </div>
//         {active && !props.mobileView && (
//           <span style={{ 
//             fontSize: '13px', 
//             fontWeight: 600,
//             whiteSpace: 'nowrap'
//           }}>
//             {label}
//           </span>
//         )}
//       </div>
//     );

//     return active ? buttonContent : (
//       <CustomTooltip title={tooltip} arrow placement="bottom">
//         <div style={{ display: 'inline-block' }}>
//           {buttonContent}
//         </div>
//       </CustomTooltip>
//     );
//   };

//   const containerStyle = {
//     backgroundColor: isDarkMode ? '#1a1a1a' : '#FFFFFF',
//     width: props.mobileView ? '90%' : `${props.desktopWidth || 440}px`,
//   };

//   const headerStyle = {
//     backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
//     borderBottomColor: isDarkMode ? '#374151' : '#e5e7eb',
//   };

//   return (
//     <>
//       {lowerModelOpen && (
//         <Paper
//           className={props.mobileView ? classes.mobileContainer : classes.modalContainer}
//           style={containerStyle}
//           elevation={0}
//         >
//           {/* Modern Header with Icon Tabs */}
//           <div className={classes.header} style={headerStyle}>
//             {/* Tool Icons */}
//             <div className={classes.tabsContainer}>
//               {/* Paraphrase Button */}
//               <TabButton
//                 active={props.paraphraser}
//                 onClick={handleParaphrase}
//                 icon={
//                   <img 
//                     src={props.paraphraser ? paraphrase_logo1 : paraphrase_logo} 
//                     alt="Paraphrase" 
//                     style={{ 
//                       width: '20px',
//                       height: '20px',
//                       transition: 'all 0.3s ease',
//                     }} 
//                   />
//                 }
//                 label="Paraphrase"
//                 color="#7C3AED"
//                 tooltip="Paraphrase"
//               />
              
//               {/* Summarize Button */}
//               <TabButton
//                 active={props.summariser}
//                 onClick={handleSummarise}
//                 icon={
//                   <FaBookOpen 
//                     style={{ 
//                       width: '18px', 
//                       height: '18px',
//                       transition: 'all 0.3s ease',
//                     }} 
//                   />
//                 }
//                 label="Summarize"
//                 color="#EF4444"
//                 tooltip="Summarize"
//               />
              
//               {/* Translator Button */}
//               <TabButton
//                 active={props.translator}
//                 onClick={handleTranslate}
//                 icon={
//                   <TranslateIcon 
//                     style={{ 
//                       width: '20px',
//                       height: '20px',
//                       transition: 'all 0.3s ease',
//                     }} 
//                   />
//                 }
//                 label="Translator"
//                 color="#F59E0B"
//                 tooltip="Translator"
//               />
//             </div>
            
//             {/* Close Button */}
//             <IconButton
//               className={classes.closeButton}
//               onClick={props.handleCloseTranslate}
//               size="small"
//               style={{ 
//                  backgroundColor: isDarkMode ? '#3b1f1f' : '#fee2e2',
//                  color: '#dc2626',
//                  transition: 'all 0.3s ease'
//               }}
//             >
//               <CloseIcon style={{ fontSize: '20px' }} />
//             </IconButton>
//           </div>

//           {/* Scrollable Content Area */}
//           <Box className={classes.contentArea}>
//             <Fade in={true} timeout={500}>
//               <div>
//                 {props.translator && (
//                   <CoAuther_TranslatorPage
//                     isDarkMode={isDarkMode}
//                     mobileView={props.mobileView}
//                     editorState={props.editorState}
//                     onGrandchildStateChange={props.onChildStateChange}
//                     editorRef={props.editorRef}
//                     editorValue={props.editorValue}
//                   />
//                 )}
//                 {props.summariser && (
//                   <CoAuther_SummariserPage
//                     isDarkMode={isDarkMode}
//                     mobileView={props.mobileView}
//                     righteditorContent={props.righteditorContent}
//                     handleDeleteinSummarizer={deleteEditorFroSummarizer}
//                     CallSummarise={props.callSummarise}
//                     editorState={props.editorState}
//                     editorValue={props.editorValue}
//                   />
//                 )}
//                 {props.paraphraser && (
//                   <CoAuther_ParaphraserPage
//                     isDarkMode={isDarkMode}
//                     mobileView={props.mobileView}
//                     editorState={props.editorState}
//                     callGrammerCheck={props.callGrammerCheck}
//                     firstTime={props.firstTime}
//                     setFirstTime={props.setFirstTime}
//                     sharedState={props.sharedState}
//                     editorValue={props.editorValue}
//                   />
//                 )}
//               </div>
//             </Fade>
//           </Box>
//         </Paper>
//       )}
//     </>
//   );
// };

// export default CoAuthorLowerModel;

import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Tooltip,
  Fade,
} from "@mui/material";
import { styled, alpha, keyframes } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";

// Icons
import CloseIcon from "@mui/icons-material/Close";
import TranslateIcon from "@mui/icons-material/Translate";
import { FaBookOpen } from "react-icons/fa";

import { openLowerModalAndCloseLeftNavbar } from "../../../redux/handleSideNavBarAndModel/handleStatus.action";
import CoAuther_TranslatorPage  from "./CoAuther_Translator/CoAuther_TranslatorPage";
import CoAuther_ParaphraserPage from "./CoAuther_Paraphraser/CoAuther_ParaphraserPage";
import CoAuther_SummariserPage  from "./CoAuther_Summariser/CoAuther_SummariserPage";

import paraphrase_logo  from "../../../static/Paraphrase 1.png";
import paraphrase_logo1 from "../../../static/Paraphraser_White.png";

// ── Design Tokens ──────────────────────────────────────────────────────────────
const C = {
  surface:     "#FFFFFF",
  surfaceAlt:  "#F8F9FE",
  border:      "rgba(120,140,220,0.18)",
  text:        "#1E2140",
  textSub:     "#4A5280",
  textMuted:   "#8891B8",
  danger:      "#EF5B5B",
  dangerLight: "#FDEAEA",
  darkSurface: "#1A1A2E",
  darkBorder:  "rgba(255,255,255,0.08)",
  darkMuted:   "#9CA3AF",
};
const R = { sm: "8px", md: "12px", lg: "16px", xl: "20px" };
const SHADOW = {
  panel: "0 0 0 1px rgba(99,120,180,0.10), -8px 0 40px rgba(30,33,64,0.10)",
};

const slideIn = keyframes`
  from { opacity:0; transform:translateX(20px); }
  to   { opacity:1; transform:translateX(0); }
`;

// ── Tool definitions ───────────────────────────────────────────────────────────
const TOOLS = [
  {
    key: "paraphrase",
    label: "Paraphrase",
    color: "#7C3AED",
    bg: "#F5F3FF",
    border: "#C4B5FD",
    darkColor: "#A78BFA",
  },
  {
    key: "summarise",
    label: "Summarize",
    color: "#EF4444",
    bg: "#FEF2F2",
    border: "#FCA5A5",
    darkColor: "#F87171",
  },
  {
    key: "translate",
    label: "Translator",
    color: "#D97706",
    bg: "#FFFBEB",
    border: "#FCD34D",
    darkColor: "#FCD34D",
  },
];

// ── Styled: Panel ─────────────────────────────────────────────────────────────
const Panel = styled(Paper, {
  shouldForwardProp: (p) => p !== "$dark",
})(({ $dark }) => ({
  position: "fixed",
  right: 0,
  top: 80,
  height: "calc(100vh - 110px)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  borderRadius: `${R.xl} 0 0 ${R.xl}`,
  border: `1px solid ${$dark ? C.darkBorder : C.border}`,
  borderRight: "none",
  boxShadow: SHADOW.panel,
  background: $dark ? C.darkSurface : C.surface,
  zIndex: 1000,
  transition: "all 0.3s ease",
}));

// ── Styled: Tab Pill ──────────────────────────────────────────────────────────
const TabPill = styled(Box, {
  shouldForwardProp: (p) => !["$active", "$color", "$bg", "$bd", "$dark"].includes(p),
})(({ $active, $color, $bg, $bd, $dark }) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: $active ? "7px 14px" : "7px 10px",
  borderRadius: R.md,
  cursor: "pointer",
  background: $active ? $bg : "transparent",
  border: `1.5px solid ${$active ? $bd : ($dark ? C.darkBorder : C.border)}`,
  color: $active ? $color : ($dark ? C.darkMuted : C.textMuted),
  transition: "all 0.15s ease",
  userSelect: "none",
  flexShrink: 0,
  "&:hover": {
    background: $bg,
    borderColor: $bd,
    color: $color,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${alpha($color, 0.18)}`,
  },
}));

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const CoAuthorLowerModel = (props) => {
  const dispatch   = useDispatch();
  const { lowerModelOpen } = useSelector((s) => s.handleModelAndSideBavBar);
  const userDetails = useSelector((u) => u);
  const userID      = userDetails.user.currentUser._id;

  const [isDark, setIsDark] = useState(false);

  // Sync dark mode
  useEffect(() => {
    const update = () => setIsDark(localStorage.getItem("ThemeSwitch") === "true");
    update();
    window.addEventListener("storage", update);
    const orig = localStorage.setItem;
    localStorage.setItem = function (k, v) {
      orig.apply(this, arguments);
      if (k === "ThemeSwitch") update();
    };
    return () => {
      window.removeEventListener("storage", update);
      localStorage.setItem = orig;
    };
  }, []);

  // ── Tab handlers ─────────────────────────────────────────────────────────────
  const handleParaphrase = () => {
    props.setTrackIsModalOpen(true);
    props.setTranslator(false);
    props.setSummariser(false);
    props.setParaphraser(true);
    dispatch(openLowerModalAndCloseLeftNavbar());
  };

  const handleSummarise = () => {
    props.setTrackIsModalOpen(true);
    props.setTranslator(false);
    props.setSummariser(true);
    props.setParaphraser(false);
    dispatch(openLowerModalAndCloseLeftNavbar());
  };

  const handleTranslate = () => {
    props.setTrackIsModalOpen(true);
    props.setTranslator(true);
    props.setSummariser(false);
    props.setParaphraser(false);
    dispatch(openLowerModalAndCloseLeftNavbar());
  };

  const tabHandlers = {
    paraphrase: handleParaphrase,
    summarise:  handleSummarise,
    translate:  handleTranslate,
  };

  const activeKey = props.paraphraser ? "paraphrase" : props.summariser ? "summarise" : props.translator ? "translate" : null;
  const activeDef = TOOLS.find((t) => t.key === activeKey);

  const panelW = props.mobileView ? "90%" : `${props.desktopWidth || 440}px`;

  // ── Render ────────────────────────────────────────────────────────────────────
  if (!lowerModelOpen) return null;

  return (
    <Panel
      elevation={0}
      $dark={isDark}
      sx={{
        width: panelW,
        ...(props.mobileView && {
          top: 135,
          right: 5,
          height: "calc(100vh - 145px)",
          borderRadius: R.xl,
          border: `1px solid ${isDark ? C.darkBorder : C.border}`,
        }),
        animation: `${slideIn} 0.25s ease`,
      }}
    >
      {/* ── Header / Tabs ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          borderBottom: `1px solid ${isDark ? C.darkBorder : C.border}`,
          background: isDark ? "rgba(255,255,255,0.04)" : C.surfaceAlt,
          flexShrink: 0,
          gap: 1,
        }}
      >
        {/* Tab pills */}
        <Box sx={{ display: "flex", gap: 0.75, flexWrap: props.mobileView ? "wrap" : "nowrap", flex: 1 }}>
          {TOOLS.map((tool) => {
            const isActive = activeKey === tool.key;
            const Icon = tool.key === "paraphrase"
              ? () => (
                  <img
                    src={isActive ? paraphrase_logo1 : paraphrase_logo}
                    alt="Paraphrase"
                    style={{ width: 18, height: 18, objectFit: "contain" }}
                  />
                )
              : tool.key === "summarise"
              ? () => <FaBookOpen style={{ fontSize: 16 }} />
              : () => <TranslateIcon sx={{ fontSize: 18 }} />;

            return (
              <Tooltip key={tool.key} title={tool.label} arrow placement="bottom">
                <TabPill
                  $active={isActive}
                  $color={isDark ? tool.darkColor : tool.color}
                  $bg={tool.bg}
                  $bd={tool.border}
                  $dark={isDark}
                  onClick={tabHandlers[tool.key]}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 20, height: 20 }}>
                    <Icon />
                  </Box>
                  {(isActive || !props.mobileView) && (
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: isActive ? 700 : 500,
                        color: isActive ? (isDark ? tool.darkColor : tool.color) : (isDark ? C.darkMuted : C.textMuted),
                        display: { xs: isActive ? "block" : "none", md: "block" },
                      }}
                    >
                      {tool.label}
                    </Typography>
                  )}
                </TabPill>
              </Tooltip>
            );
          })}
        </Box>

        {/* Close */}
        <IconButton
          onClick={props.handleCloseTranslate}
          size="small"
          sx={{
            width: 32, height: 32, borderRadius: R.sm,
            background: isDark ? "rgba(239,91,91,0.15)" : C.dangerLight,
            color: C.danger,
            border: `1px solid ${alpha(C.danger, 0.2)}`,
            flexShrink: 0,
            transition: "all 0.15s",
            "&:hover": { background: C.danger, color: "#fff", transform: "rotate(90deg)" },
          }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>

      {/* Active tool label strip */}
      {activeDef && (
        <Box
          sx={{
            px: 2.5, py: 1,
            borderBottom: `1px solid ${isDark ? C.darkBorder : C.border}`,
            background: isDark ? "rgba(255,255,255,0.03)" : activeDef.bg,
            display: "flex", alignItems: "center", gap: 1,
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              width: 6, height: 6, borderRadius: "50%",
              background: isDark ? activeDef.darkColor : activeDef.color,
            }}
          />
          <Typography
            sx={{
              fontWeight: 700, fontSize: "12px",
              color: isDark ? activeDef.darkColor : activeDef.color,
              letterSpacing: "0.03em",
              textTransform: "uppercase",
            }}
          >
            {activeDef.label}
          </Typography>
        </Box>
      )}

      {/* ── Scrollable Content ── */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          background: isDark ? C.darkSurface : C.surface,
          scrollbarWidth: "thin",
          scrollbarColor: `${isDark ? "rgba(255,255,255,0.1)" : C.border} transparent`,
          "&::-webkit-scrollbar": { width: "5px" },
          "&::-webkit-scrollbar-thumb": {
            background: isDark ? "rgba(255,255,255,0.12)" : C.border,
            borderRadius: "3px",
          },
        }}
      >
        <Fade in timeout={400}>
          <Box>
            {props.translator && (
              <CoAuther_TranslatorPage
                isDarkMode={isDark}
                mobileView={props.mobileView}
                editorState={props.editorState}
                onGrandchildStateChange={props.onChildStateChange}
                editorRef={props.editorRef}
                editorValue={props.editorValue}
              />
            )}
            {props.summariser && (
              <CoAuther_SummariserPage
                isDarkMode={isDark}
                mobileView={props.mobileView}
                righteditorContent={props.righteditorContent}
                handleDeleteinSummarizer={(v) => v && props.handleDeleteinSummarizer(true)}
                CallSummarise={props.callSummarise}
                editorState={props.editorState}
                editorValue={props.editorValue}
              />
            )}
            {props.paraphraser && (
              <CoAuther_ParaphraserPage
                isDarkMode={isDark}
                mobileView={props.mobileView}
                editorState={props.editorState}
                callGrammerCheck={props.callGrammerCheck}
                firstTime={props.firstTime}
                setFirstTime={props.setFirstTime}
                sharedState={props.sharedState}
                editorValue={props.editorValue}
              />
            )}
          </Box>
        </Fade>
      </Box>
    </Panel>
  );
};

export default CoAuthorLowerModel;
